// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "b910555dbe816fed-dirty",
    "hash": "b910555dbe816fed",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b910555dbe816fed-dirty",
    "semverString": null,
    "version": "0.0.0"
};
/* tslint:enable */
